import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { BehaviorSubject, Observable, map } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { IOrganizationSettings } from '../../models/organization-settings.model';

@Injectable({
  providedIn: 'root'
})
export class AccountingService {

  constructor(private http: HttpClient) { }

  getB2BGroups(): Observable<any> {
    return this.http.get<any>(`${environment.configUrlV2}/PosVendor`);
  }


  getPosVendordetails(vendorName, posConsumerId: number, storeId: string, pageNumber: number, pageSize: number) {
    let params = new HttpParams();
    params = params.append('pagenumber', pageNumber)
    params = params.append('pagesize', pageSize)
    return this.http.get<any>(`${environment.posVendor}PosVendor/Vendor/${vendorName}/Consumer/${posConsumerId}/Store/${storeId}/Products`,{ observe: 'response', params }) .pipe(
      map((res: HttpResponse<any>) => {
        return {
          posDetails: res.body,
          headers: JSON.parse(res.headers.get('x-pagination'))
        };
      })
    );
  }



  getListingDetails(vendorName,posConsumerId,channelId,pageNumber,pageSize) {
    let params = new HttpParams();
    params = params.append('pagenumber', pageNumber)
    params = params.append('pagesize', pageSize)
    return this.http.get<any>(`${environment.posVendor}PosVendor/Vendor/${vendorName}/Consumer/${posConsumerId}/MappedAccount/${channelId}`,{ observe: 'response', params }) .pipe(
      map((res: HttpResponse<any>) => {
        return {
          posVendorList: res.body,
          headers: JSON.parse(res.headers.get('x-pagination'))
        };
      })
    );
  }

  getFieldMappingListing(vendorId,posConsumerId): Observable<any>{
    return this.http.get<any>(`${environment.posVendor}PosVendor/Vendor/${vendorId}/Consumer/${posConsumerId}/FieldMappingPageList`);
  }

  fieldMappingPosFields(vendorName,posConsumerId): Observable<any>{
    return this.http.get<any>(`${environment.posVendor}PosVendor/Vendor/${vendorName}/Consumer/${posConsumerId}/Stores`);
  }


  saveB2BGroup(data): Observable<any> {
    return this.http.post<any>(`${environment.configUrlV2}/PosVendor/PosConsumer`,data);
  }

  uninstallB2BGroup(PosConsumerid) : Observable<any>{
    return this.http.delete<any>(`${environment.configUrlV2}/PosVendor/PosConsumer/${PosConsumerid}`);
  }
  updateB2BGroup(PosConsumerid) : Observable<any> {
    return this.http.get<any>(`${environment.configUrlV2}/PosVendor/PosConsumer/${PosConsumerid}`);
  }

   posConsumerB2BGroup(PosConsumerid) : Observable<any> {
   return this.http.get<any>(`${environment.configUrlV2}/PosVendor/PosVendorFieldMapping/PosComsumerId/${PosConsumerid}`);
   }

   posVendorFieldMappingB2BGroup(data): Observable<any> {
    return this.http.post<any>(`${environment.configUrlV2}/PosVendor/PosVendorFieldMapping`,data);
  }

  getIntegrationGroups(): Observable<any> {
    return this.http.get<any>(`${environment.integrationUrl}Group`);
  }

  getIntegrationTypes(groupId){
    return this.http.get<any>(`${environment.integrationUrl}Type?groupId=${groupId}`);
  }

  getAllIntegrationDetails(typeId){
    return this.http.get<any>(`${environment.integrationUrl}QBOrganizationSettings?integrationTypeId=${typeId}`);
  }

  getAllWarehouse(){
    let params = new HttpParams();
    params = params.append('PageNumber', '0')
    params = params.append('PageSize', '0')
    params = params.append('SearchValue', '')
    return this.http.get<any>(`${environment.inventoryURl}WareHouse/AllWarehouseDetails`, { params });
  }

  getAllQBWarehouse(){
    return this.http.get<any>(`${environment.integrationUrl}QBWareHouse`);
  }

  authenticateQBOnline(code: string, isSandBox: boolean, url: string){
    return this.http.get(`${environment.integrationUrl}Authentication?code=${code}&redirectUrl=${url}&isSandbox=${isSandBox}`, { responseType: 'text' })
  }

  qbOnlineDisconnect(id: number){
    return this.http.get(`${environment.integrationUrl}Authentication/DisconnectQBOnline?id=${id}`);
  }

  getQBOnlineInstallStatus(vendorName: string){
    return this.http.get<any>(`${environment.vendorUrl}VendorOAuthRegistration/VendorOAuthRegistrationByVendorName?vendorName=${vendorName}`);
  }

  deleteVendor(id) {
    return this.http.delete<any>(`${environment.vendorUrl}VendorOAuthRegistration/${id}`);
  }

  getUserByVendorAuthRegistrationId(id: number){
    return this.http.get<any>(`${environment.vendorUrl}VendorOAuthRegistrationUser/UserByVendorOAuthRegistrationId?Id=${id}`);
  }

  getAllVendorRegistration(){
    return this.http.get<any>(`${environment.vendorUrl}VendorOAuthRegistration/AllVendorOAuthRegistrationByVendorName?vendorName=QBOnline`);
  }

  saveVendorRegistration(vendor){
    return this.http.post<any>(`${environment.vendorUrl}VendorOAuthRegistration`, vendor);
  }

  saveQBOnlineOrganizationSettings(organizationSettings: IOrganizationSettings){
    return this.http.post<any>(`${environment.integrationUrl}QBOrganizationSettings`, organizationSettings);
  }

  savePaymentTerm(){
    return this.http.post<any>(`${environment.integrationUrl}PaymentTerm`, {});
  }

  savePaymentMethod(){
    return this.http.post<any>(`${environment.integrationUrl}PaymentMethod`, {});
  }

  saveProduct(){
    return this.http.post<any>(`${environment.integrationUrl}Product`, {});
  }

  saveInvoice(){
    return this.http.post<any>(`${environment.integrationUrl}Invoice`, {});
  }

  saveReceivePayment(){
    return this.http.post<any>(`${environment.integrationUrl}Invoice/AddReceivePaymentToLionO`, {});
  }

  addAccountsToQB(){
    return this.http.post<any>(`${environment.integrationUrl}QBSync/ToQB/Account`, {});
  }
  addAccountsToLionO(){
    return this.http.get<any>(`${environment.integrationUrl}QBSync/ToLionO/Account`);
  }
  addVendorToQB(){
    return this.http.post<any>(`${environment.integrationUrl}QBSync/ToQB/Vendor`, {});
  }
  addVendorToLionO(){
    return this.http.post<any>(`${environment.integrationUrl}QBSync/ToLionO/Vendor`, {});
  }
  addBillsToQB(){
    return this.http.post<any>(`${environment.integrationUrl}QBSync/Bill`, {});
  }
  addBillPaymentToLionO(){
    return this.http.post<any>(`${environment.integrationUrl}QBSync/BillPayment`, {});
  }
  addProductAsServiceToLionO(){
    return this.http.get<any>(`${environment.integrationUrl}Product/ToLionO/ProductAsService`);
  }
  addServiceAsProducts(){
    return this.http.get<any>(`${environment.integrationUrl}QBSync/ToLionO/ServicesAsProducts`);
  }

  saveQBOnlineAuthenticationData(urlParams){
    let code = urlParams.get('code');
    let state = urlParams.get('state');
    let realmId = urlParams.get('realmId');
    console.log('code ===>>>>', code);
    console.log('state ===>>>>', state);
    console.log('realmId ===>>>>', realmId);
    return this.http.get<any>(`${environment.integrationUrl}Authentication/AccessToken?code=${code}&state=${state}&realmId=${realmId}`);
  }

  installQB(data){
    return this.http.post<any>(`${environment.integrationUrl}QBOrganizationSettings`, data)
    .toPromise()
    .then(res => res);
  }

  unInstallQB(id){
    return this.http.delete<any>(`${environment.integrationUrl}QBOrganizationSettings/${id}`)
  }

  updateQB(data){
    return this.http.put<any>(`${environment.integrationUrl}QBOrganizationSettings`, data)
    .toPromise()
    .then(res => res);
  }

  updateWarehousMappingeData(data){
    return this.http.put<any>(`${environment.integrationUrl}QBWarehouseMapping`, data)
    .toPromise()
    .then(res => res);
  }

  getAllMappingData(){
    return this.http.get<any>(`${environment.integrationUrl}ObjectFieldMapping`);
  }

  updateMappingeData(data){
    return this.http.put<any>(`${environment.integrationUrl}ObjectFieldMapping`, data)
    .toPromise()
    .then(res => res);
  }
}
